import { Pipe, PipeTransform } from '@angular/core';

/*
 * Returns the Address
 * Takes an object argument (Address Info).
 *
 * @Params:
 * Does not take extra parameters
 *
 * Usage:
 *   address | AddressTooltipFnPipe
 *
 * Example:
 *   {{ address | AddressTooltipFnPipe }}
 *   formats to: Address1 Address2 Address3 Address4 \n city state postal country
*/

@Pipe({
  name: 'ivAddressTooltipFn'
})
export class AddressTooltipFnPipe implements PipeTransform {
  constructor() {
  }
  transform(address: any): string {
    if (address) {
      const address1 = address.address1 && (address.address1).trim() !== '' ? address.address1 : '';
      const address2 = address.address2 && (address.address2).trim() !== '' ? address.address2 : '';
      const address3 = address.address3 && (address.address3).trim() !== '' ? address.address3 : '';
      const address4 = address.address4 && (address.address4).trim() !== '' ? address.address4 : '';
      let city = '', state = '', postal = '', country = '';
      let GSTIN = '';
      let label = '';
      if (address.label && (address.label).trim() !== '') {
        label = address.label.trim() + ',';
      }
      if (address.city && (address.city).trim() !== '') {
        city = address.city.trim() + ',';
      }
      if (address.state && (address.state).trim() !== '') {
        state = address.state.trim() + ',';
      }
      if (address.postal && (address.postal).trim() !== '') {
        postal = address.postal.trim() + ',';
      }
      if (address.country && (address.country).trim() !== '') {
        country = address.country.trim();
      }
      if (address.stx_cst_rgstn && (address.stx_cst_rgstn).trim() !== '') {
        GSTIN = address.stx_cst_rgstn.trim();
      }
      return `${label} ${address1} ${address2} ${address3} ${address4} \n ${city} ${state} ${postal} ${country} ${GSTIN ? '\n GSTIN: ' + GSTIN : ''}`;
    }
    return '';
  }
}
